import generateAdjustedEventTraits from 'src/js/modules/element-settings/helpers/generate-adjusted-event-traits';
import generateModifiedEventTraits from 'src/js/modules/element-settings/helpers/generate-modified-event-traits';
import { BORDER_RADIUSES } from '../settings/border-radiuses';

const getCornersAdjustedEventTraits = ({ eventTraitPrefix }) =>
  generateAdjustedEventTraits(eventTraitPrefix, 'Corners');

const getCornersModifiedEventTraits = ({ eventTraitPrefix, attribute, newValue, oldValue }) => {
  const attrRelatedOptionId = Object.values(BORDER_RADIUSES).find(({ attributes }) =>
    attributes.includes(attribute)
  ).id;

  return generateModifiedEventTraits(eventTraitPrefix, attrRelatedOptionId, oldValue, newValue);
};

export { getCornersAdjustedEventTraits, getCornersModifiedEventTraits };
